<div class="results-container">
  <div class="header-section d-flex justify-content-between align-items-center">
    <div class="title-area">
      <h2 class="page-title">{{ 'dash.interviewResults' | translate }}</h2>
      <p class="page-subtitle">
        {{ 'dash.interviewId' | translate }} <span class="separator">|</span>
        <span class="highlight">{{ interviewId || '-' }}</span>
      </p>
    </div>
    <div class="action-area">
      <button class="btn btn-setup" (click)="goBack()">{{ 'dash.backToInterviews' | translate }}</button>
    </div>
  </div>

  <div class="metrics-section">
    <h3 class="results-section-title">{{ 'dash.keyMetrics' | translate }}</h3>
    <div class="row custom-row">
      <div class="col-6 col-md-3">
        <div class="metric-card border-red">
          <p class="metric-label">{{ 'dash.totalCandidates' | translate }}</p>
          <h4 class="metric-value blue-text">{{ formatValue(keyMetrics.totalCandidates) }}</h4>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="metric-card border-orange">
          <p class="metric-label">{{ 'dash.completionRateLabel' | translate }}</p>
          <h4 class="metric-value blue-text">{{ formatValue(keyMetrics.completionRate) }}%</h4>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="metric-card border-yellow">
          <p class="metric-label">{{ 'dash.avgScore' | translate }}</p>
          <h4 class="metric-value blue-text">{{ formatScore(keyMetrics.averageScore) }}</h4>
        </div>
      </div>
      <div class="col-6 col-md-3">
        <div class="metric-card border-pink">
          <p class="metric-label">{{ 'dash.strongFit' | translate }}</p>
          <h4 class="metric-value blue-text">{{ formatValue(keyMetrics.strongFitCandidates) }}</h4>
        </div>
      </div>
    </div>
  </div>

  <div class="results-list-section mt-5">
    <h3 class="results-section-title">{{ 'dash.resultsList' | translate }}</h3>

    <div class="loading-state" *ngIf="isLoading">
      <i class="bi bi-hourglass-split spin"></i>
      <span>{{ 'dash.loadingResults' | translate }}</span>
    </div>

    <div class="table-container d-none d-md-block" *ngIf="!isLoading">
      <table class="interviews-table">
        <thead>
          <tr>
            <th>{{ 'dash.rank' | translate }}</th>
            <th>{{ 'dash.candidate' | translate }}</th>
            <th>{{ 'dash.overallScore' | translate }}</th>
            <th>{{ 'dash.aiRecommend' | translate }}</th>
            <th>{{ 'dash.dateCompleted' | translate }}</th>
            <th>{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of resultsList">
            <td>{{ formatValue(result.rank) }}</td>
            <td>{{ formatValue(result.candidateName) }}</td>
            <td>{{ formatScore(result.overallScore) }}</td>
            <td>
              <span class="recommend-pill" [ngClass]="getRecommendationClass(result.aiRecommend)">
                {{ formatValue(result.aiRecommend) }}
              </span>
            </td>
            <td>{{ formatDate(result.dateCompleted) }}</td>
            <td>
              <button class="btn btn-link action-link" (click)="viewRanking(result)">{{ 'dash.viewRanking' | translate }}</button>
            </td>
          </tr>
          <tr *ngIf="resultsList.length === 0">
            <td colspan="6" class="no-results">{{ 'dash.noResults' | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards-container d-block d-md-none mt-3" *ngIf="!isLoading">
      <div *ngFor="let result of resultsList" class="job-card">
        <div class="card-body two-columns">
          <div class="card-field">
            <span class="card-field-label">{{ 'dash.candidate' | translate }}</span>
            <span class="col-job-name">{{ formatValue(result.candidateName) }}</span>
          </div>
          <div class="card-field">
            <span class="card-field-label">{{ 'dash.rank' | translate }}</span>
            <span>{{ formatValue(result.rank) }}</span>
          </div>
          <div class="card-field">
            <span class="card-field-label">{{ 'dash.overallScore' | translate }}</span>
            <span>{{ formatScore(result.overallScore) }}</span>
          </div>
          <div class="card-field border-bottom-0">
            <span class="card-field-label">{{ 'dash.aiRecommend' | translate }}</span>
            <span class="recommend-pill" [ngClass]="getRecommendationClass(result.aiRecommend)">
              {{ formatValue(result.aiRecommend) }}
            </span>
          </div>
          <div class="card-field border-bottom-0">
            <span class="card-field-label">{{ 'dash.dateCompleted' | translate }}</span>
            <span class="col-date">{{ formatDate(result.dateCompleted) }}</span>
          </div>
        </div>
        <div class="card-actions">
          <button class="btn btn-link action-link btn-card-action" (click)="viewRanking(result)">{{ 'dash.viewRanking' | translate }}</button>
        </div>
      </div>
      <div *ngIf="resultsList.length === 0" class="no-results">{{ 'dash.noResults' | translate }}</div>
    </div>

    <div class="pagination-row" *ngIf="totalPages > 1 && !isLoading">
      <span class="pagination-info">
        {{ 'dash.showingResults' | translate:{ first: firstItem, last: lastItem, total: totalElements } }}
      </span>
      <div class="pagination-controls">
        <button class="page-btn nav-btn" [disabled]="activePage === 1" (click)="goToPage(activePage - 1)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <ng-container *ngFor="let p of pageNumbers">
          <span *ngIf="p === -1" class="page-dots">...</span>
          <button *ngIf="p !== -1" class="page-btn" [class.page-active]="p === activePage" (click)="goToPage(p)">
            {{ p }}
          </button>
        </ng-container>
        <button class="page-btn nav-btn" [disabled]="activePage === totalPages" (click)="goToPage(activePage + 1)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="16" height="16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
